export const NERDWALLET_DISCLOSURE = `
NerdWallet Advisors (“NWA”) has entered a collaboration with Zoe
Financial, Inc. (“Zoe”), an unaffiliated SEC-registered
investment adviser with a broad network of financial advisors.
You have been referred to Zoe through the NerdWallet Advisor
Match Powered by Zoe experience. Zoe uses the information you
provided to match you with an advisor from its network. Zoe pays
cash compensation to NWA in exchange for client referrals. This
creates a conflict of interest, as NWA has a financial incentive
to refer you to Zoe. NWA is not a client of Zoe and is not
involved in Zoe’s matching process or in the advisory services
you may receive from any advisor introduced by Zoe.
`;

export const NERDWALLET_NOSQL_DISCLOSURE = `
In addition to the registered investment advisers, you have also been referred to Uprise, a membership-based financial planning product. We are not a client of Uprise and have not received any compensation in exchange for client referrals. However, we do have a separate collaboration arrangement with Uprise, which presents a conflict of interest, as this relationship could influence the endorsement.
`;

export const VALID_ASSET_ID_TYPES: number[] = [1, 3, 4];

export const MAX_AGE_FOR_SQL_VALIDATION = 60;
export const MIN_ASSETS_FOR_SQL_VALIDATION = 200_000;
export const MAX_ASSETS_FOR_SQL_VALIDATION = 250_000;
